import React from 'react'
import { MotionButton, MotionDiv, MotionImage, MotionSection } from '../motion/Motion'

export default function ProductsHero() {
  return (
    <MotionSection className="w-[96%] mx-auto -mt-2 sm:-mt-3 lg:-mt-4 py-12 lg:py-16">
      <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
        <MotionDiv className="space-y-5" delay={0.02}>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight text-gray-900">
            Get in Touch with Your
            <br />
            Local Matting Experts
          </h1>
          <p className="text-sm sm:text-base text-gray-700 leading-relaxed max-w-xl">
            Whether you need a custom quote, technical advice on material selection, or an update on your order, our dedicated team is
            here to help.
          </p>

          <div className="pt-2">
            <button className="rounded-full bg-pink-500 px-6 py-2 text-sm font-semibold text-white shadow hover:bg-pink-600 transition-colors">
              <MotionButton>Shop Now</MotionButton>
            </button>
          </div>
        </MotionDiv>

        <MotionImage className="w-full lg:-mt-6" delay={0.08}>
          <img
            src="/images/sectionimages/products%20hero.png"
            alt="Products hero"
            className="w-full h-auto object-contain"
          />
        </MotionImage>
      </div>
    </MotionSection>
  )
}
